// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"IdentificationTagScreen_buttonsContainer__WjE5P","button":"IdentificationTagScreen_button__KtvNY"};